export const tabs = [
  {
    text: 'Code',
    icon: 'code'
  },
  {
    text: 'Issues',
    icon: 'issues',
    count: true
  },
  {
    text: 'Pull requests',
    icon: 'pullRequests',
    count: true
  },
  {
    text: 'Actions',
    icon: 'actions'
  },
  {
    text: 'Projects',
    icon: 'projects'
  },
  {
    text: 'Wiki',
    icon: 'wiki'
  },
  {
    text: 'Security',
    icon: 'security'
  },
  {
    text: 'Insights',
    icon: 'insights'
  }
];